import "./styles/documentsStyle/documentStyle.css";
import { pdfData } from "../../assets/pdf/index";

import { withNamespaces } from "react-i18next";

function DocumentBox({ text, document }) {
  function handleClickDocument() {
    // PDF görüntüleyiciyi açmak için yeni bir pencere oluşturun
    window.open(document, "_blank");
  }
  return (
    <div className="document-box-container" onClick={handleClickDocument}>
      <i className="fa-solid fa-file-pdf" />
      <div className="document-name">
        <p>{text}</p>
      </div>
    </div>
  );
}

function DocumentsPage({ t }) {
  return (
    <div className="documents-page-container">
      <DocumentBox
        text={t("offerex_user_guide")}
        document={pdfData.offerExTutorialPdf}
      />
    </div>
  );
}

export default withNamespaces()(DocumentsPage);
